import { post } from '@utils/request'

/**
 * 获取文章详情 
 * http://api.quzao.com/api.php?do=supplier_help_detail&help
 */
export function supplier_help_detail(data) {
  return post('supplier_help_detail', data)
}
